export default function PHP_AjaxDatabase() {
  return (
    <div>
      <h1>PHP_AjaxDatabase</h1>
    </div>
  );
}
